import styled, { css } from "styled-components";
import theme from "styled-theming";
import colors from "../styles/colors";
import { ThemeType } from "../styles/theme";

export enum ProcessTriggerChipVariant {
    active = "active",
    deactivated = "deactivated",
    warning = "warning",
    error = "error"
}

const chipBackgroundColor = theme("mode", {
    [ThemeType.light]: colors.purplePrimary,
    [ThemeType.dark]: colors.purplePrimary
});

const darkBlueChipBackgroundColor = theme("mode", {
    [ThemeType.light]: colors.blueDark,
    [ThemeType.dark]: colors.blueDark
});

const processTagBackgroundColor = theme("mode", {
    [ThemeType.light]: colors.grey_3,
    [ThemeType.dark]: colors.darkPurpleTagBackground
})

const processTagColor = theme("mode", {
    [ThemeType.light]: colors.black,
    [ThemeType.dark]: colors.white
})

const processTagBorderColor = theme("mode", {
    [ThemeType.light]: colors.black,
    [ThemeType.dark]: colors.darkPurpleTagBorder
})

const processTagHoleBackgroundColor = theme("mode", {
    [ThemeType.light]: colors.white,
    [ThemeType.dark]: colors.dark2
})

const processTriggerChipTextColor = theme.variants("mode", "variant", {
    [ProcessTriggerChipVariant.active]: {
        [ThemeType.light]: colors.white,
        [ThemeType.dark]: colors.white,
    },
    [ProcessTriggerChipVariant.deactivated]: {
        [ThemeType.light]: colors.white,
        [ThemeType.dark]: colors.white,
    },
    [ProcessTriggerChipVariant.warning]: {
        [ThemeType.light]: colors.white,
        [ThemeType.dark]: colors.white,
    },
    [ProcessTriggerChipVariant.error]: {
        [ThemeType.light]: colors.grey_1,
        [ThemeType.dark]: colors.white,
    }
})

const processTriggerChipBackgroundColor = theme.variants("mode", "variant", {
    [ProcessTriggerChipVariant.active]: {
        [ThemeType.light]: colors.blueDark,
        [ThemeType.dark]: colors.blueDark
    },
    [ProcessTriggerChipVariant.deactivated]: {
        [ThemeType.light]: colors.grey_2,
        [ThemeType.dark]: colors.grey_2
    },
    [ProcessTriggerChipVariant.warning]: {
        [ThemeType.light]: colors.orangePrimary,
        [ThemeType.dark]: colors.orangePrimary
    },
    [ProcessTriggerChipVariant.error]: {
        [ThemeType.light]: colors.warningTertiary,
        [ThemeType.dark]: colors.darkWarningPrimary
    }
})

const errorChipBackgroundColor = theme("mode", {
    [ThemeType.light]: colors.warningDark,
    [ThemeType.dark]: colors.warningDark2
});

export const Chip = styled.span`
    color: ${colors.white};
    background-color: ${chipBackgroundColor};
    border-radius: 20px;
    text-align: center;
    padding: 8px 16px;
    font-size: 1rem;
`

export const DarkBlueChip = styled(Chip)`
    background-color: ${darkBlueChipBackgroundColor};
`

const ProcessTagCss = css`
    background-color: ${processTagBackgroundColor};
    color: ${processTagColor};
    border: 1px solid;
    border-color: ${processTagBorderColor};
    border-radius: 20px;
    padding: 5px 8px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    line-height: 18px;
    gap: 5px;
    font-size: 1rem;
`

export const ProcessTag = styled.p`
    ${ProcessTagCss};
`

export const ProcessTagButton = styled.button`
    ${ProcessTagCss};
    cursor: pointer;
`

export const ProcessTagHole = styled.div`
    min-width: 12px;
    min-height: 12px;
    border: 1px solid;
    background-color: ${processTagHoleBackgroundColor};
    border-color: ${processTagBorderColor};
    border-radius: 50%;
`

export const ProcessTriggerChip = styled.span`
    color: ${processTriggerChipTextColor};
    background-color: ${processTriggerChipBackgroundColor};
    border-radius: 20px;
    text-align: center;
    padding: 8px 16px;
    font-size: 1rem;
`
export const ErrorChip = styled(Chip)`
    background-color: ${errorChipBackgroundColor};
`

export const SmallErrorChip = styled(ErrorChip)`
    padding: 2px 8px;
    font-size: var(--small-text-font-size);
`